export default __webpack_public_path__ + "static/media/rules-football.765d6f99.svg";